export default "__VITE_ASSET__66708252__"